<div class="table-responsive">
  <table class="table table-nowrap mb-0">
    <colgroup appColEvenly [cols]="showAccount ? 4 : 3"></colgroup>
    <thead>
      <tr>
        <th *ngIf="showAccount">Account</th>
        <th>Time</th>
        <th>Market</th>
        <th>Type</th>
        <th class="text-end">Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let record of records">
        <td *ngIf="showAccount">
          <app-address [address]="record.account" [category]="record.category" [note]="record.note"></app-address>
        </td>
        <td>
          <a [href]="ethWalletService.getTxUrl(record.txHash)" target="_blank" rel="noopener">{{ (record.timestamp * 1000) | date: 'MMM dd, y, HH:mm' }}</a>
        </td>
        <td>
          <div class="d-flex align-items-center">
            <img class="me-2" [src]="'/retired-arbitrum/assets/images/' + record.marketName.split('-')[0].toLocaleLowerCase() + '.svg'" />{{ record.marketName }}
          </div>
        </td>
        <td>
          <span [translate]="'fund.type.' + record.fundType"></span>
        </td>
        <td class="text-end">
          <ngx-money
            [class.text-success]="record.amount.gt(0)"
            [class.text-danger]="record.amount.lt(0)"
            [value]="record.amount"
            [precision]="2"
            [signed]="true"
            symbol="$"
          ></ngx-money>
        </td>
      </tr>
    </tbody>
  </table>
</div>
